import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import frenchFlag from "../../assets/flags/france.png";
import englishFlag from "../../assets/flags/UK.png";
import spanishFlag from "../../assets/flags/spain.png";
import slovenianFlag from "../../assets/flags/slovenia.png";
import Box from "@mui/material/Box";

const LanguageMenu: React.FC = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const languageTab: { lang: string; text: string; flag: string }[] = [
    { lang: "fr", text: `${t("language.fr")}`, flag: frenchFlag },
    { lang: "en", text: `${t("language.en")}`, flag: englishFlag },
    { lang: "esp", text: `${t("language.esp")}`, flag: spanishFlag },
    { lang: "slo", text: `${t("language.slo")}`, flag: slovenianFlag },
  ];

  const changeLanguage = React.useCallback((lang: string) => {
    return i18n.changeLanguage(lang);
  }, []);

  const getLanguageFlag = React.useMemo(() => {
    switch (i18n.language) {
      case "en": {
        return englishFlag;
      }
      case "fr": {
        return frenchFlag;
      }
      case "esp": {
        return spanishFlag;
      }
      case "slo": {
        return slovenianFlag;
      }
    }
  }, [i18n.language]);

  return (
    <Box>
      <Button
        id="basic-button"
        onClick={handleClick}
        sx={(theme) => ({
          [theme.breakpoints.up("md")]: {
            height: "30px",
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        })}
      >
        <img
          src={getLanguageFlag || englishFlag}
          height={25}
          alt={"currentLanguage"}
        />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {languageTab.map((item) => (
          <MenuItem
            onClick={() => changeLanguage(item.lang)}
            disabled={item.lang === i18n.language}
          >
            <img src={item.flag} height={"25px"} alt={"language"} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export { LanguageMenu };
